<template>
  <div>
    <div class="flex-table">
      <div class="flex-table-header">
        <div class="flex-table-header-element" style="flex: 1">
          <span>项目类型/得分</span>
        </div>
        <div style="flex: 4; display: flex">
          <div class="flex-table-header-element" style="flex: 1">
            <span>考核项</span>
          </div>
          <div class="flex-table-header-element" style="flex: 0.6">
            <span>原始分</span>
          </div>
          <div class="flex-table-header-element" style="flex: 0.6">
            <span>折算分</span>
          </div>
          <div class="flex-table-header-element" style="flex: 0.6">
            <span>满分</span>
          </div>
          <div class="flex-table-header-element" style="flex: 3.5">
            <span>考核项说明</span>
          </div>
        </div>
        <div class="flex-table-header-element" style="flex: 1">
          <span>备注</span>
        </div>
      </div>
      <div
        class="flex-table-content"
        v-for="item in currentDetail"
        :key="item.id"
      >
        <div class="flex-table-content-element title" style="flex: 1">
          <span
            >{{ item.parent.name
            }}<span class="high-light-green">{{ item.parent.score }}</span
            >分</span
          >
        </div>
        <div class="appraisal" style="flex: 4">
          <div
            v-for="item2 in item.childList"
            :key="item2.id"
            style="display: flex; height: 100%"
          >
            <div
              class="appraisal-element"
              style="flex: 1; justify-content: center"
            >
              <span>{{ item2.name }}</span>
            </div>
            <div
              class="appraisal-element"
              style="flex: 0.6; justify-content: center"
            >
              <span>{{ item2.sourceScore }}</span>
            </div>
            <div
              class="appraisal-element"
              style="flex: 0.6; justify-content: center"
            >
              <span>{{ item2.score }}</span>
            </div>
            <div
              class="appraisal-element"
              style="flex: 0.6; justify-content: center"
            >
              <span>{{ item2.topLimit }}</span>
              <!-- <span>{{ item2.singleScore*item2.targetNum }}</span> -->
            </div>
            <div class="appraisal-element" style="flex: 3.5">
              <span>{{ item2.calcDesc }}</span>
            </div>
          </div>
        </div>
        <div class="flex-table-content-element title" style="flex: 1">
          <span>{{ item.parent.calcDesc }}</span>
        </div>
      </div>
    </div>
    <div class="descriptions">
      <!--        <span>截止<span class="high-light-red">2020-12-12 10:06:05</span>时</span><br>-->
      <!--        <span>成绩<span class="high-light-red blod" style="font-size:16px">200</span>分</span><br>-->
      <!--        <span>如果成绩未更新，请稍后或第二天手动<span class="high-light-red" @click="freshScore()">刷新成绩！</span></span>-->
        <span v-if="tips" class="high-light-red">{{ tips || '' }}</span>
        <span class="high-light-red simulation-a" @click="freshScore()"
          >刷新成绩</span
        >
        <!-- v-if="isEdit === 0" -->
        <!--        <span style="margin-left:10px;">(成绩{{currentScoreFirst !== 0 ? currentScoreFirst : currentScore}}分)</span>-->
        <!-- <span v-if="isEdit === 1" style="margin-left:10px;">(成绩{{currentScore}}分，本成绩为校方提供)</span> -->
      </span>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { mapState } from "vuex";
export default {
  props: {
    currentDetail: Object,
    currentScore: null,
    currentUpdateTime: String,
    scoreId: String,
    isEdit: Number
  },
  computed:{
    ...mapState(["userInfo"]),
  },
  data() {
    return {
      currentScoreFirst: null,
      tips: ''
    }
  },
  watch: {
  },
  methods: {
    freshScore() {
      this.axios.get(`/biz/score/freshscore`, { params: { eduCode: this.userInfo.eduCode, score_id: this.scoreId } }).then((res) => {
        this.$emit('getDeatilAllValue', this.scoreId)
      })
    },

    getTips() {
      this.axios.get('/biz/score/infoDesc', { params: { score_id: this.scoreId } }).then(res => {
        if (res.success) {
          if (res.result) {
            this.tips = res.result
          }
        }
      })
    },

  },

  mounted () {
    this.getTips()
  }
}
</script>

<style lang="scss">
.flex-table {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  color: #999999;
  font-size: 14px;

  &-header {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;

    &-element {
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid #dee2e6;
      margin-top: -1px;
      margin-left: -1px;
      height: 40px;
      padding: 10px;
      box-sizing: border-box;
    }
  }

  &-content {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: stretch;

    &-element {
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid #dee2e6;
      margin-top: -1px;
      margin-left: -1px;
      padding: 10px;
      box-sizing: border-box;
    }

    .appraisal {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: stretch;

      &-element {
        display: flex;
        // justify-content: center;
        align-items: center;
        border: 1px solid #dee2e6;
        margin-top: -1px;
        margin-left: -1px;
        padding: 10px;
        box-sizing: border-box;
      }
    }

    .title {
      background-color: #eff5f2;
    }
  }
}

.descriptions {
  margin: 20px auto;
  text-align: center;
}

.high-light-green {
  color: #2caf7a;
  font-weight: bold;
}

.high-light-red {
  color: #ff0000;
}

.blod {
  font-weight: bold;
}

.simulation-a {
margin-left: 10px;
  cursor: pointer;

  &:hover {
    color: #1890ff;
    text-decoration: underline;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/myscore/components/gradeInfo.vue